module.exports = __webpack_public_path__ + "img/30.18324cc4.jpg";